import { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';

import { ExcelUtils } from 'utils';

import Row from '../Row';

const EMPTY_OBJ = {};
const SerieDatapointRow = ({ address = "", clearTable, formula, refreshCall, parsedParameters = EMPTY_OBJ }) => {
  const goToAddress = useCallback(() => ExcelUtils.goToAddress(address), [address]),
        parsedSymbol = useMemo(() => Object.entries(parsedParameters?.symbol || {}).map(([key, value]) => ({ key, value: [value] })), [parsedParameters]),
        localName = useMemo(() => {
          const symbolValues = parsedSymbol.flatMap(({ value }) => value)
          return `${parsedParameters?.groupName || ""} ${symbolValues.join(" ")}`
        }, [parsedParameters?.groupName, parsedSymbol])

  return (
    <Row
        address={address}
        formula={formula}
        name={localName}
        onClear={clearTable}
        onRefresh={refreshCall}
    >
      <div className="ng-office-app__authed__content__active-calls__row__cell ng-office-app__authed__content__active-calls__row__cell--group">
        <div className="ng-office-app__authed__content__active-calls__row__cell__top">
          Group: 
        </div>
        <div className="ng-office-app__authed__content__active-calls__row__cell__bottom">
          {parsedParameters?.groupName ? parsedParameters?.groupName : "-"}
        </div>
      </div>
      <div className="ng-office-app__authed__content__active-calls__row__cell ng-office-app__authed__content__active-calls__row__cell--address">
        <div className="ng-office-app__authed__content__active-calls__row__cell__top">
          Cell reference:
        </div>
        <div
            className="ng-office-app__authed__content__active-calls__row__cell__bottom"
            onClick={goToAddress}
        >
          {address}
        </div>
      </div>
      {parsedSymbol.map(({ key, value }, index) => (
        <div
            className="ng-office-app__authed__content__active-calls__row__cell ng-office-app__authed__content__active-calls__row__cell--symbol"
            key={key + value + index}
        >
          <div className="ng-office-app__authed__content__active-calls__row__cell__top">
            {key}:
          </div>
          <div className="ng-office-app__authed__content__active-calls__row__cell__bottom">
            {value}
          </div>
        </div>
      ))}
      <div className="ng-office-app__authed__content__active-calls__row__cell ng-office-app__authed__content__active-calls__row__cell--columns">
        <div className="ng-office-app__authed__content__active-calls__row__cell__top">
          Column:
        </div>
        <div className="ng-office-app__authed__content__active-calls__row__cell__bottom">
          {parsedParameters?.column || "-"}
        </div>
      </div>
      <div className="ng-office-app__authed__content__active-calls__row__cell ng-office-app__authed__content__active-calls__row__cell--date">
        <div className="ng-office-app__authed__content__active-calls__row__cell__top">
          Date:
        </div>
        <div className="ng-office-app__authed__content__active-calls__row__cell__bottom">
          {parsedParameters?.date ? parsedParameters?.date : "-"}
        </div>
      </div>
    </Row>
  )
}

SerieDatapointRow.propTypes = {
  address: PropTypes.string,
  clearTable: PropTypes.func.isRequired,
  formula: PropTypes.string.isRequired,
  parsedParameters: PropTypes.object,
  refreshCall: PropTypes.func.isRequired,
}

export default SerieDatapointRow;